module.exports = __webpack_public_path__ + "static/media/eye.274caf30.svg";